'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isSameDate = (date1, date2) => {
    return (date1.getUTCFullYear() === date2.getUTCFullYear() &&
        date1.getUTCMonth() === date2.getUTCMonth() &&
        date1.getUTCDate() === date2.getUTCDate());
};

exports.isSameDate = isSameDate;
//# sourceMappingURL=is-same-date.js.map
